export class MobileTools {
    public static get IsMobile() {
        const windowAsAny = window as any;
        return navigator.userAgent.indexOf('Mobile') > -1 || (windowAsAny.webkit && windowAsAny.webkit.messageHandlers);
    }
}
